export const CREATE_NEW_UNIT_CHECKIN_PROFILE =
  '[unit] create new unit checkin profile';
export const PROCESS_NEW_UNIT_CHECKIN_PROFILE =
  '[unit] process new unit checkin profile';
export const PROCESS_UNIT_CHECKIN_PROFILE =
  '[unit] process unit checkin profile';
export const LOAD_UNIT_CHECKIN_PROFILE = '[unit] load unit checkin profile';
export const INSERT_UNIT_CHECKIN_PROFILE = '[unit] insert unit checkin profile';
export const EDIT_UNIT_CHECKIN_PROFILE = '[unit] edit unit checkin profile';
export const UNIT_CHECKIN_PROFILE_ERROR = '[unit] unit checkin profile error';
export const UNIT_CHECKIN_PROFILE_CREATE_ERROR =
  '[unit] unit checkin profile create error';

export const editUnitCheckinProfile = (
  profile,
  navigate,
  previous,
  formSteps
) => ({
  type: EDIT_UNIT_CHECKIN_PROFILE,
  payload: profile,
  navigate: navigate,
  previous,
  formSteps,
});
export const createNewUnitCheckinProfile = (
  profile,
  navigate,
  previous,
  formSteps
) => ({
  type: CREATE_NEW_UNIT_CHECKIN_PROFILE,
  payload: profile,
  navigate: navigate,
  previous,
  formSteps,
});
export const processUnitCheckinProfile = () => ({
  type: PROCESS_UNIT_CHECKIN_PROFILE,
});
export const processNewUnitCheckinProfile = () => ({
  type: PROCESS_NEW_UNIT_CHECKIN_PROFILE,
});
export const loadUnitCheckinProfile = (id) => ({
  type: LOAD_UNIT_CHECKIN_PROFILE,
  payload: id,
});
export const insertUnitCheckinProfile = (profile) => ({
  type: INSERT_UNIT_CHECKIN_PROFILE,
  payload: profile,
});

export const unitCheckinProfileError = (error) => ({
  type: UNIT_CHECKIN_PROFILE_ERROR,
  payload: error,
});
export const unitCheckinProfileCreateError = (error) => ({
  type: UNIT_CHECKIN_PROFILE_CREATE_ERROR,
  payload: error,
});
